/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import axios from "axios";
import { endpoints } from "../services/apiurl";
import { DateRangePicker } from "react-date-range";
import DateRangeIcon from "@material-ui/icons/DateRange";
import {
  Paper,
  CardContent,
  Typography,
  Grid,
  Button,
  FormControl,
  Divider,
  Box,
  Avatar,
  Card
} from "@mui/material";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { InfinitySpin } from "react-loader-spinner";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import FeedbackIcon from "@mui/icons-material/Feedback";
import NotificationsActiveIcon from "@mui/icons-material/Subscriptions";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import Modal from "react-modal";
import { format } from "date-fns";
import { withRouter } from "react-router-dom";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
Modal.setAppElement("#root");
class IndexDashboard extends Component {


  handleClickReservation = () => {
    const { restro_id, start_date, end_date } = this.state;
    let { type } = this.state;

    const queryParams = {};

    if (restro_id) {
      queryParams.restro_id = restro_id;
      if (!start_date || !end_date) {
        const today = new Date().toISOString().split("T")[0];
        queryParams.start_date = today;
        queryParams.end_date = today;
      } else {
        queryParams.start_date = start_date;
        queryParams.end_date = end_date;
      }
      queryParams.type = "1";
    } else if (start_date && end_date) {
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
      queryParams.type = type || "1";
    } else {
      // If no filters are selected, use today's date
      const today = new Date().toISOString().split("T")[0];
      queryParams.start_date = today;
      queryParams.end_date = today;
      queryParams.type = "1";
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString
      ? `/dashboard/reservationleads?${queryString}`
      : "/dashboard/reservationleads";

    this.props.history.push(url);
  };

  handleClickFeedback = () => {
    const { restro_id, start_date, end_date } = this.state;
    let { type } = this.state;

    const queryParams = {};

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const now = new Date();
    const today = formatDate(now);
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    if (restro_id && (!start_date || !end_date)) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = today;
      queryParams.end_date = today;
      queryParams.type = "3";
    }
    // Case when both dates and restaurant are selected
    else if (start_date && end_date && restro_id) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
      queryParams.type = type || "3";
    }
    // Case when both dates are selected
    else if (start_date && end_date) {
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
      queryParams.type = type || "3";
    } else {
      queryParams.start_date = formatDate(startOfMonth);
      queryParams.end_date = formatDate(endOfMonth);
      queryParams.type = "3";
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString
      ? `/dashboard/feedback?${queryString}`
      : "/dashboard/feedback";

    this.props.history.push(url);
  };

  handleClickEvents = () => {
    const { restro_id, start_date, end_date } = this.state;

    const queryParams = {};

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const now = new Date();
    const today = formatDate(now);
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    if (restro_id && (!start_date || !end_date)) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = today;
      queryParams.end_date = today;
    }
    // Case when both dates and restaurant are selected
    else if (start_date && end_date && restro_id) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    }
    // Case when both dates are selected
    else if (start_date && end_date) {
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    } else {
      queryParams.start_date = formatDate(startOfMonth);
      queryParams.end_date = formatDate(endOfMonth);
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString
      ? `/dashboard/eventleads?${queryString}`
      : "/dashboard/eventleads";

    this.props.history.push(url);
  };

  handleClickContactus = () => {
    const { restro_id, start_date, end_date } = this.state;

    const queryParams = {};

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const now = new Date();
    const today = formatDate(now);
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    if (restro_id && (!start_date || !end_date)) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = today;
      queryParams.end_date = today;
    }
    // Case when both dates and restaurant are selected
    else if (start_date && end_date && restro_id) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    }
    // Case when both dates are selected
    else if (start_date && end_date) {
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    } else {
      queryParams.start_date = formatDate(startOfMonth);
      queryParams.end_date = formatDate(endOfMonth);
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString
      ? `/dashboard/contactusleads?${queryString}`
      : "/dashboard/contactusleads";

    this.props.history.push(url);
  };

  handleClickSubscribeUs = () => {
    const { restro_id, start_date, end_date } = this.state;

    const queryParams = {};

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const now = new Date();
    const today = formatDate(now);
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    if (restro_id && (!start_date || !end_date)) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = today;
      queryParams.end_date = today;
    }
    // Case when both dates and restaurant are selected
    else if (start_date && end_date && restro_id) {
      queryParams.restro_id = restro_id;
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    }
    // Case when both dates are selected
    else if (start_date && end_date) {
      queryParams.start_date = start_date;
      queryParams.end_date = end_date;
    } else {
      queryParams.start_date = formatDate(startOfMonth);
      queryParams.end_date = formatDate(endOfMonth);
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString
      ? `/dashboard/subscribeusleads?${queryString}`
      : "/dashboard/subscribeusleads";

    this.props.history.push(url);
  };

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      rest: [],
      showModal: false,
      DataisLoaded: false,
      res_msg: "",
      fd_msg: "",
      event_msg: "",
      reservation_count: 0,
      feedback_count: 0,
      event_count: 0,
      subscribe_count: 0,
      contact_count: 0,
      restro_id: "",
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
      displayText: "Select Date Range",
    };
    this.start_date = moment(new Date()).format("YYYY-MM-DD");
    this.end_date = moment(new Date()).format("YYYY-MM-DD");
  }
  componentDidMount() {
    this.getRestaurentsDropDown();
    this.fetchData();
  }

  fetchData = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userRestroId = user.restro_id;
    const restro_id =
      userRestroId === 0 ? this.state.restro_id || userRestroId : userRestroId;

    axios
      .post(endpoints.getdashboardData, { restro_id })
      .then((response) => {
        this.setState({
          res_msg: response.data.res_msg,
          fd_msg: response.data.fd_msg,
          event_msg: response.data.event_msg,
          contact_msg: response.data.contact_msg,
          subscribe_msg: response.data.subscribe_msg,

          reservation_count: response.data.reservation_count[0]?.total || 0,
          feedback_count: response.data.feedback_count[0]?.total || 0,
          event_count: response.data.event_count[0]?.total || 0,
          contact_count: response.data.contact_count[0]?.total || 0,
          subscribe_count: response.data.subscribe_count[0]?.total || 0,

          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  };

  getRestaurentsDropDown = async () => {
    try {
      const response = await axios.post(endpoints.getRestaurentsDropDown);
      this.setState({ rest: response.data.data });
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  filtercount = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const restro_id =
      user.restro_id === 0
        ? this.state.restro_id || user.restro_id
        : user.restro_id;
    let { start_date, end_date } = this.state;

    let payload = { restro_id };

    if (start_date) {
      payload.start_date = start_date;
    }
    if (end_date) {
      payload.end_date = end_date;
    }

    axios
      .post(endpoints.getdashboardDatafilter, payload)
      .then((response) => {
        const isDefaultDate = !start_date || !end_date;
        this.setState({
          res_msg: isDefaultDate
            ? "Today's Reservation"
            : response.data.res_msg || "Total Reservation",
          fd_msg: isDefaultDate
            ? "Today's Fill Feedback"
            : response.data.fd_msg || "Total Feedback",
          event_msg: isDefaultDate
            ? "Today's Created Event Booking"
            : response.data.event_msg || "Total Event Booking",
          contact_msg: isDefaultDate
            ? "Today's Contact Leads"
            : response.data.contact_msg || "Total Contact Leads",
          subscribe_msg: isDefaultDate
            ? "Today's Subscribe Leads"
            : response.data.subscribe_msg || "Total Subscribe Leads",

          reservation_count: response.data.reservation_count[0]?.total || 0,
          feedback_count: response.data.feedback_count[0]?.total || 0,
          event_count: response.data.event_count[0]?.total || 0,
          contact_count: response.data.contact_count[0]?.total || 0,
          subscribe_count: response.data.subscribe_count[0]?.total || 0,
        });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  };

  handleSelect = (ranges) => {
    const startDate = moment(ranges.selection.startDate).format("YYYY-MM-DD");
    const endDate = moment(ranges.selection.endDate).format("YYYY-MM-DD");
    this.setState(
      {
        selectionRange: ranges.selection,
        start_date: startDate,
        end_date: endDate,
      },
      this.filtercount
    );
  };

  onInputChange = (e) => {
    this.setState({ restro_id: e.target.value }, this.filtercount);
  };

  onFilterChange = (e) => {
    this.setState({ restro_id: e.target.value }, this.filtercount);
  };

  resetFilter = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userRestroId = user.restro_id;

    this.setState(
      {
        restro_id: userRestroId === 0 ? "" : userRestroId,
        selectionRange: {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
        start_date: "",
        end_date: "",
        displayText: "Select Date Range",
        res_msg: "Today's Reservation",
        fd_msg: "Today's Fill Feedback",
        event_msg: "Today's Created Event Booking",
        contact_msg: "Today's Contact Leads",
        subscribe_msg: "Today's Subscribe Leads",
      },
      this.fetchData
    );
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  applyDateRange = () => {
    const { startDate, endDate } = this.state.selectionRange;
    const displayText = `${format(startDate, "MMM d, yyyy")} - ${format(
      endDate,
      "MMM d, yyyy"
    )}`;
    this.setState(
      {
        displayText,
        showModal: false,
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
      },
      () => {
        this.filtercount();
      }
    );
  };

  render() {
    const {
      DataisLoaded,
      rest,
      res_msg,
      fd_msg,
      event_msg,
      contact_msg,
      subscribe_msg,
      reservation_count,
      feedback_count,
      event_count,
      contact_count,
      subscribe_count,
      restro_id,
      selectionRange,
      showModal,
      displayText,
    } = this.state;
    // console.log('State rest:', rest);
    const a = this.state.items;
    const user = JSON.parse(localStorage.getItem("user"));
    const userRestroId = user.restro_id;

    // const b = JSON.stringify(a)
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );



    return (
      <div>
        <Grid container spacing={2} className="mt-2">
          {userRestroId === 0 && (
            <Grid item xs={12} sm={5}>
              <FormControl fullWidth>
                <select
                  name="restro_id"
                  required
                  className="form-control"
                  value={this.state.restro_id}
                  onChange={this.onInputChange}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "7px",
                    height: "41px",
                    cursor: "pointer",
                  }}
                >
                  <option value="" className="text-dark">
                    Select Restaurant
                  </option>
                  {rest.map((e, key) => {
                    return (
                      <option key={key} value={e.id}>
                        {e.name}
                      </option>
                    );
                  })}
                </select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={5}>
            <FormControl fullWidth>
              <div
                className="filter-button"
                onClick={this.toggleModal}
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  justifyContent: "space-between",
                  padding: "7px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              >
                <Typography
                  style={{ marginRight: "10px" }}
                  className="text-dark"
                >
                  {displayText}
                </Typography>
                <DateRangeIcon style={{ fontSize: "24px" }} />
              </div>
            </FormControl>
            <Modal
              isOpen={showModal}
              onRequestClose={this.toggleModal}
              contentLabel="Select Date Range"
              style={{
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                },
              }}
            >
              <DateRangePicker
                ranges={[selectionRange]}
                onChange={this.handleSelect}
              />

              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary text-white px-4"
                  onClick={this.applyDateRange}
                  style={{ marginTop: "10px" }}
                >
                  Apply Filter
                </button>
              </div>
            </Modal>
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.resetFilter}
            >
              Reset Filter
            </Button>
          </Grid>
        </Grid>

        <div className="row mt-5">
       
          {/* <Grid container spacing={2} className="mt-4">
            <Grid item xs={12} sm={4}>
              <Paper elevation={3} style={{ borderRadius: "10px" }}>
                <CardContent style={{ display: "flex", alignItems: "center" }}>
                  <ReceiptIcon
                    style={{
                      fontSize: "40px",
                      marginRight: "10px",
                      color: "#fbab1a",
                    }}
                    className="mb-2"
                  />
                  <div
                    style={{ flexGrow: 1, textAlign: "right" }}
                    className="pt-3"
                  >
                    <Typography variant="h6" style={{ fontSize: "17px" }}>
                      {res_msg}
                    </Typography>
                    <Typography variant="h6">{reservation_count}</Typography>
                  </div>
                </CardContent>
                <Divider />
                <div
                  className="py-2 text-center"
                  onClick={this.handleClickReservation}
                  style={{ cursor: "pointer" }}
                >
                  <h6 className="text-info" style={{ fontWeight: "600" }}>
                    View More
                  </h6>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper elevation={3} style={{ borderRadius: "10px" }}>
                <CardContent style={{ display: "flex", alignItems: "center" }}>
                  <FeedbackIcon
                    style={{
                      fontSize: "40px",
                      marginRight: "10px",
                      color: "#fbab1a",
                    }}
                  />
                  <div
                    style={{ flexGrow: 1, textAlign: "right" }}
                    className="pt-3"
                  >
                    <Typography variant="h6" style={{ fontSize: "17px" }}>
                      {fd_msg}
                    </Typography>
                    <Typography variant="h6">{feedback_count}</Typography>
                  </div>
                </CardContent>
                <Divider />
                <div
                  className="py-2 text-center"
                  onClick={this.handleClickFeedback}
                  style={{ cursor: "pointer" }}
                >
                  <h6 className="text-info" style={{ fontWeight: "600" }}>
                    View More
                  </h6>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper elevation={3} style={{ borderRadius: "10px" }}>
                <CardContent style={{ display: "flex", alignItems: "center" }}>
                  <EventAvailableIcon
                    style={{
                      fontSize: "40px",
                      marginRight: "10px",
                      color: "#fbab1a",
                    }}
                    className="mb-2"
                  />
                  <div
                    style={{ flexGrow: 1, textAlign: "right" }}
                    className="pt-3"
                  >
                    <Typography variant="h6" style={{ fontSize: "17px" }}>
                      {event_msg}
                    </Typography>
                    <Typography variant="h6">{event_count}</Typography>
                  </div>
                </CardContent>
                <Divider />
                <div
                  className="py-2 text-center"
                  onClick={this.handleClickEvents}
                  style={{ cursor: "pointer" }}
                >
                  <h6 className="text-info" style={{ fontWeight: "600" }}>
                    View More
                  </h6>
                </div>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={4} className="mt-4">
              <Paper elevation={3} style={{ borderRadius: "10px" }}>
                <CardContent style={{ display: "flex", alignItems: "center" }}>
                  <ContactMailIcon
                    style={{
                      fontSize: "40px",
                      marginRight: "10px",
                      color: "#fbab1a",
                    }}
                    className="mb-2"
                  />
                  <div
                    style={{ flexGrow: 1, textAlign: "right" }}
                    className="pt-3"
                  >
                    <Typography variant="h6" style={{ fontSize: "17px" }}>
                      {contact_msg}
                    </Typography>
                    <Typography variant="h6">{contact_count}</Typography>
                  </div>
                </CardContent>
                <Divider />
                <div
                  className="py-2 text-center"
                  onClick={this.handleClickContactus}
                  style={{ cursor: "pointer" }}
                >
                  <h6 className="text-info" style={{ fontWeight: "600" }}>
                    View More
                  </h6>
                </div>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={4} className="mt-4">
              <Paper elevation={3} style={{ borderRadius: "10px" }}>
                <CardContent style={{ display: "flex", alignItems: "center" }}>
                  <NotificationsActiveIcon
                    style={{
                      fontSize: "40px",
                      marginRight: "10px",
                      color: "#fbab1a",
                    }}
                    className="mb-2"
                  />
                  <div
                    style={{ flexGrow: 1, textAlign: "right" }}
                    className="pt-3"
                  >
                    <Typography variant="h6" style={{ fontSize: "17px" }}>
                      {subscribe_msg}
                    </Typography>
                    <Typography variant="h6">{subscribe_count}</Typography>
                  </div>
                </CardContent>
                <Divider />
                <div
                  className="py-2 text-center"
                  onClick={this.handleClickSubscribeUs}
                  style={{ cursor: "pointer" }}
                >
                  <h6 className="text-info" style={{ fontWeight: "600" }}>
                    View More
                  </h6>
                </div>
              </Paper>
            </Grid>
          </Grid> */}


{/* demo code2 */}

<Grid container spacing={3}>
      <Grid item lg={3}>
        <Card className="mt-2" style={{ 
         backgroundColor: 'rgb(231 182 58 / 8%)',
          width: 300, 
         borderRadius: 16, 
          padding: '16px', 
          display: 'flex', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}>
          <div style={{ flex: 1 }}>
            <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 500, }}>
             {res_msg}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              {reservation_count}
            </Typography>
            <Typography className="mt-2" style={{ color: '#e7b63a', fontWeight: 500, cursor: "pointer" }} variant="body2" onClick={this.handleClickReservation}>
              View more <ChevronRightIcon style={{ color: '#e7b63a', fontSize: 20, fontWeight: 500 }} />
            </Typography>
          </div>
          <Avatar style={{ 
            backgroundColor: '#e7b63a', 
            width: 40, 
            height: 40 
          }}>
            <EventSeatIcon style={{ color: '#fff', fontSize: 25 }} />
          </Avatar>
        </Card>
      </Grid>

      {/* Card 2 */}
      <Grid item lg={3}>
        <Card className="mt-2" style={{ 
         backgroundColor: 'rgb(231 182 58 / 8%)', 
          width: 300, 
         borderRadius: 16, 
          padding: '16px', 
          display: 'flex', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}>
          <div style={{ flex: 1 }}>
            <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 500 }}>
             {fd_msg}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              {feedback_count}
            </Typography>
            <Typography className="mt-2" style={{ color: '#e7b63a', fontWeight: 500, cursor: "pointer" }} variant="body2" onClick={this.handleClickFeedback}>
              View more <ChevronRightIcon style={{ color: '#e7b63a', fontSize: 20, fontWeight: 500 }} />
            </Typography>
          </div>
          <Avatar style={{ 
            backgroundColor: '#e7b63a', 
            width: 40, 
            height: 40 
          }}>
            <FeedbackIcon style={{ color: '#fff', fontSize: 20 }} />
          </Avatar>
        </Card>
      </Grid>

      {/* Card 3 */}
      <Grid item lg={3}>
        <Card className="mt-2" style={{ 
         backgroundColor: 'rgb(231 182 58 / 8%)', 
          width: 300, 
         borderRadius: 16, 
          padding: '16px', 
          display: 'flex', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}>
          <div style={{ flex: 1 }}>
            <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 500, }}>
              {event_msg}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
             {event_count}
            </Typography>
            <Typography className="mt-2" style={{ color: '#e7b63a', fontWeight: 500, cursor: "pointer" }} variant="body2" onClick={this.handleClickEvents}>
              View more <ChevronRightIcon style={{ color: '#e7b63a', fontSize: 20, fontWeight: 500 }} />
            </Typography>
          </div>
          <Avatar style={{ 
            backgroundColor: '#e7b63a', 
            width: 40, 
            height: 40 
          }}>
            <EventAvailableIcon style={{ color: '#fff', fontSize: 25 }} />
          </Avatar>
        </Card>
      </Grid>

      {/* Card 4 */}
      <Grid item lg={3}>
        <Card className="mt-2" style={{ 
         backgroundColor: 'rgb(231 182 58 / 8%)', 
          width: 300, 
         borderRadius: 16, 
          padding: '16px', 
          display: 'flex', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}>
          <div style={{ flex: 1 }}>
            <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 500, }}>
              {contact_msg}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              {contact_count}
            </Typography>
            <Typography className="mt-2" style={{ color: '#e7b63a', fontWeight: 500, cursor: "pointer" }} variant="body2" onClick={this.handleClickContactus}>
              View more <ChevronRightIcon style={{ color: '#e7b63a', fontSize: 20, fontWeight: 500 }} />
            </Typography>
          </div>
          <Avatar style={{ 
            backgroundColor: '#e7b63a', 
            width: 40, 
            height: 40 
          }}>
            <ContactMailIcon style={{ color: '#fff', fontSize: 20 }} />
          </Avatar>
        </Card>
      </Grid>


      <Grid item lg={3}>
        <Card className="mt-2" style={{ 
         backgroundColor: 'rgb(231 182 58 / 8%)', 
          width: 300, 
          borderRadius: 16, 
          padding: '16px', 
          display: 'flex', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}>
          <div style={{ flex: 1 }}>
            <Typography variant="subtitle1" color="textSecondary" style={{ fontWeight: 500, }}>
              {subscribe_msg}
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>
              {subscribe_count}
            </Typography>
            <Typography className="mt-2" style={{ color: '#e7b63a', fontWeight: 500, cursor: "pointer" }} variant="body2" onClick={this.handleClickSubscribeUs}>
              View more <ChevronRightIcon style={{ color: '#e7b63a', fontSize: 20, fontWeight: 500 }} />
            </Typography>
          </div>
          <Avatar style={{ 
            backgroundColor: '#e7b63a', 
            width: 40, 
            height: 40 
          }}>
            <SubscriptionsIcon style={{ color: '#fff', fontSize: 20 }} />
          </Avatar>
        </Card>
      </Grid>
    </Grid>
 
        </div>
      </div>
    );
  }
}
export default withRouter(IndexDashboard);
